<template>
  <!--begin::Content wrapper-->
  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="online-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
            شحن المحفظة Online 
          </h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> إغلاق
          </button>
        </div>
        <div class="modal-body">
          <!--<div class="support-box"><img class="support-img text-center" src="assets/images/icon.png" alt=""></div>-->
          <h4 class="mb-2 text-center support-text">أدخل أدناه قيمة الشحن</h4>
          <form @submit.prevent="handleSubmit" class="form-horizontal">
            <div style="min-height: 10px"></div>
            <div class="row" dir="rtl">
              <div class="col-md-12">
                <div class="form-group form-group-custom mb-4" dir="rtl">
                  <label for="online-amount"> قيمة الشحن د.ل</label>
                  <input
                    type="text"
                    class="form-control"
                    id="online-amount"
                    v-model="amount"
                    placeholder="أدخل قيمة الرصيد المراد شحنه"
                  />
                </div>
                <div class="mt-2"></div>
              </div>
            </div>
            <hr />

            <button
              class="p-3 btn btn-primary waves-effect waves-light float-end btn-charge"
              type="submit"
              :disabled="isLoading"
            >
              تأكيد <i class="fa fa-check-circle"></i>
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              عودة
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!--end::Content wrapper-->
</template>

<script>
 
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure

export default {
  name: "Online",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      amount: "",
      isLoading: false,
    };
  },
  mounted() {
      
  },
  methods: {
    async handleSubmit() {
      try {
        const result = await Swal.fire({
          title: "هل أنت متأكد من العملية؟",
          text: " سيتم تحويلك لبوابة الدفع (Online) ",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3ddc97",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "لا",
          confirmButtonText: "نعم",
        });

        if (result.isConfirmed) {
          this.isLoading = true;

          const response = await fetch(`${apiUrl}/wallets/charge-online`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
            body: JSON.stringify({
              amount: this.amount,
            }),
          });

          if (!response.ok) {
            const errorResponse = await response.json();
            throw errorResponse;
          }

          const responseData = await response.json();
          window.location.href = responseData.url;
        }
      } catch (error) {
        this.isLoading = false;

        if (error.errors) {
          const errors = error.errors;
          if (errors.code === "هذا الكرت غير صالح") {
            Swal.fire("هذا الكرت غير صالح", "", "error");
          } else {
            Object.values(errors).forEach((errorMessage) => {
              Swal.fire("خطأ", errorMessage.join(", "), "error");
            });
          }
        } else {
          Swal.fire("خطأ", "حدث خطأ ما. الرجاء المحاولة مرة أخرى.", "error");
        }
      }
    } 
  },
};
</script>

<style scoped>
.icon-img {
  margin-bottom: 10px;
  width: 150px;
}
#online-amount {
  text-align: center;
  border: 0px;
  background: #ededed;
  height: unset;
}
.btn-charge {
  padding: 10px 50px;
  font-weight: 600;
  background: rgb(0 180 64);
}
</style>
